import { postRequest, getRequest } from "../../app/axiosClient";
import { setClaimRecords } from "./ClaimsSlice";
export const GetClaimsApi = (values) => (dispatch) => {
  try {
    const queryParams = new URLSearchParams();

    if (values.status) queryParams.append("status", values.status);
    if (values.createdAfter)
      queryParams.append("createdAfter", values.createdAfter);
    queryParams.append("pageNumber", values.pageNumber || 1);
    queryParams.append("pageSize", values.pageSize || 10);
    queryParams.append("search", values.search || "");

    return getRequest(`api/Claims/GetClaims?${queryParams.toString()}`)
      .then((res) => {
        dispatch(
          setClaimRecords({
            data: res?.data?.items,
            totalPages: res?.data?.totalPages,
            totalCount: res?.data?.totalCount,
            pageNo: values.pageNumber,
            search: values.search,
          })
        );
        return { payload: res?.data?.data };
      })
      .catch((e) => {
        console.error("Error fetching claims:", e);
      });
  } catch (e) {
    return false;
  }
};
export const CreateMinimalClaimApi = (payload) => async (dispatch) => {
  try {
    const response = await postRequest(`api/Claims/create-minimal`, payload);

    return { success: true, data: response?.data };
  } catch (error) {
    console.error("Error creating minimal claim:", error);
    return { success: false, error };
  }
};
export const GetProtectionPlanDetailsApi = async ({
  planNumber = null,
  email = null,
}) => {
  try {
    if (!planNumber && !email) {
      return {
        success: false,
        error: "Either planNumber or email must be provided",
      };
    }

    const params = new URLSearchParams();
    if (planNumber) params.append("planNumber", planNumber);
    if (email) params.append("email", email.trim().toLowerCase());

    const response = await getRequest(
      `api/Claims/GetProtectionPlanDetails?${params.toString()}`
    );

    return {
      success: true,
      payload: response.data,
    };
  } catch (error) {
    console.error("API Error:", error);
    return {
      success: false,
      error:
        error.response?.data?.message ||
        error.message ||
        "Something went wrong",
    };
  }
};
export const GetClaimDetailApi = async (claimId) => {
  try {
    const response = await getRequest(`api/Claims/GetClaimDetail/${claimId}`);
    return {
      success: true,
      payload: response.data,
    };
  } catch (error) {
    console.error("Error fetching claim detail:", error);
    return {
      success: false,
      error: error.response?.data || "Failed to fetch claim detail",
    };
  }
};

export const UpdateClaimApi = (payload) => async (dispatch) => {
  try {
    const response = await postRequest(`api/Claims/UpdateClaim`, payload);

    return { success: true, data: response?.data };
  } catch (error) {
    console.error("Error creating minimal claim:", error);
    return { success: false, error };
  }
};
